/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MergeDocumentsResponse
 */
export interface MergeDocumentsResponse {
    /**
     * 
     * @type {string}
     * @memberof MergeDocumentsResponse
     */
    documentId: string;
}

/**
 * Check if a given object implements the MergeDocumentsResponse interface.
 */
export function instanceOfMergeDocumentsResponse(value: object): value is MergeDocumentsResponse {
    if (!('documentId' in value) || value['documentId'] === undefined) return false;
    return true;
}

export function MergeDocumentsResponseFromJSON(json: any): MergeDocumentsResponse {
    return MergeDocumentsResponseFromJSONTyped(json, false);
}

export function MergeDocumentsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MergeDocumentsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'documentId': json['documentId'],
    };
}

export function MergeDocumentsResponseToJSON(json: any): MergeDocumentsResponse {
    return MergeDocumentsResponseToJSONTyped(json, false);
}

export function MergeDocumentsResponseToJSONTyped(value?: MergeDocumentsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documentId': value['documentId'],
    };
}

